<template>
  <template v-if="signedUrls.length">
    <img
      v-for="(url, index) in signedUrls"
      :key="index"
      :src="url"
      :class="imgClass"
      :alt="alt"
    />
  </template>
</template>

<script setup>
import { ref, watch } from 'vue'
import { resolveSignedUrlsFromField } from '@/utils/ossImage.js'

const props = defineProps({
  value: { type: [String, Array, Object], default: '' },
  imgClass: { type: String, default: 'record-img' },
  alt: { type: String, default: '' },
})

const signedUrls = ref([])

watch(
  () => props.value,
  async (raw) => {
    if (raw == null || raw === '') {
      signedUrls.value = []
      return
    }
    try {
      signedUrls.value = await resolveSignedUrlsFromField(raw)
    } catch {
      signedUrls.value = []
    }
  },
  { immediate: true },
)
</script>
